var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.25C2.08579 7.25 1.75 7.58579 1.75 8C1.75 8.41421 2.08579 8.75 2.5 8.75L2.5 7.25ZM15.0303 8.53033C15.3232 8.23744 15.3232 7.76256 15.0303 7.46967L10.2574 2.6967C9.96447 2.40381 9.48959 2.40381 9.1967 2.6967C8.90381 2.98959 8.90381 3.46447 9.1967 3.75736L13.4393 8L9.1967 12.2426C8.90381 12.5355 8.90381 13.0104 9.1967 13.3033C9.48959 13.5962 9.96447 13.5962 10.2574 13.3033L15.0303 8.53033ZM2.5 8.75L14.5 8.75L14.5 7.25L2.5 7.25L2.5 8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7c46e9d17cbff1b594592e42b0935d5a.svg";
export { ForwardRef as ReactComponent };